<app-widget-option [categories]="['LAYERS', 'DATES']" [label]="'FILL_BLANKS'">
  <div app-widget-option-content>
    <app-check [color]="color" [value]="widgetLayers.layer(current).fillBlanks" (sendValue)="receiveValue($event)"></app-check>
  </div>
</app-widget-option>